// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.saleBadge {
  font-size: 0.8rem !important;
  width: auto;
}

.item-box-hidding {
  display: none;
}

.item-box {
  background: #fff;
  overflow: hidden;
  border: 1px solid #e3e3e2;
  /* box-shadow: 0.1px 1px 7px 0 rgb(144 144 144 / 30%); */
  padding: 8px;
  position: relative;
  height: 100%;
}
.item-box .details-box {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 2px;
}
.item-box .details-box .image-box {
  width: 15%;
  height: 80px;
  order: 2;
  overflow: hidden;
}
.item-box .details-box .agent-box {
  order: 5;
}
.item-box .details-box .desc-box {
  overflow: hidden;
  text-align: start;
  min-height: 95px;
  order: 1;
}
.item-box .details-box .desc-box .title {
  font-size: 1rem;
  line-height: 1;
  min-height: 33px;
}
.item-box .details-box .desc-box .flex-box {
  align-items: flex-start;
  flex-direction: column;
}
.item-box .details-box .desc-box .subtitle {
  margin-top: 3px;
  font-size: 13px;
  color: #3b3b3b;
  order: 1;
}
.item-box .details-box .desc-box .description {
  line-height: 1;
  font-size: 13px;
  overflow: hidden;
  display: none;
}
.item-box .details-box .desc-box .description ::ng-deep p {
  margin: 0;
}
.item-box .details-box .desc-box .description ::ng-deep h3 {
  margin: 0;
  font-size: 12px;
}
.item-box .details-box .desc-box .properties-box {
  display: flex;
  align-items: center;
  flex-direction: row;
  order: 2;
}
.item-box .details-box .desc-box .properties-box .maker-img {
  padding: 3px;
  height: 40px;
  line-height: 0.7;
}
.item-box .details-box .desc-box .properties-box .maker-img span {
  font-size: 13px;
}
.item-box .details-box .desc-box .properties-box .props-view-box ::ng-deep item-props-view .color-prop-box.small {
  width: 15px;
  height: 15px;
}
.item-box .details-box .desc-box .properties-box .props-view-box ::ng-deep item-props-view .colors-row {
  text-align: end;
}
.item-box .details-box .desc-box .properties-box .props-view-box ::ng-deep item-props-view .props-row {
  white-space: initial;
  text-align: end;
}
.item-box .options-box {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 2px;
  align-items: center;
  order: 3;
  width: 100%;
}
.item-box .options-box .cart-options {
  width: 66%;
}
.item-box .options-box .cart-options ion-buttons.space-around {
  justify-content: space-around;
}
.item-box .options-box .cart-options ion-buttons.flex-start {
  justify-content: flex-start;
}
.item-box .options-box .cart-options ion-buttons {
  display: flex;
  flex-direction: row;
  align-items: center;
  overflow: hidden;
}
.item-box .options-box .cart-options ion-buttons ion-button {
  width: 100%;
  font-size: 12px;
  height: 35px;
  max-width: 150px;
}
.item-box .options-box .cart-options ion-buttons ion-button .opacity-backg {
  position: absolute;
  z-index: 1;
  width: 100%;
  height: 100%;
  border-radius: 0;
  background: none;
  --background: none;
}
.item-box .options-box .cart-options ion-buttons ion-button .opacity-backg.strong {
  opacity: 0.4;
}
.item-box .options-box .cart-options ion-buttons ion-button * {
  z-index: 2;
}
.item-box .options-box .cart-options ion-buttons.btn-outline ion-button {
  background: none;
  --background: none;
  font-weight: bold;
  --padding-end: 0;
  --padding-start: 0;
}
.item-box .options-box .cart-options ion-buttons.btn-outline ion-button.text-only {
  border: 0;
  font-size: 20px;
  --padding-start: 0;
  --padding-end: 0;
}
.item-box .options-box .cart-options ion-buttons.btn-outline ion-button.text-only span {
  font-size: 15px;
  color: #e3e3e2;
  font-weight: 100;
}
.item-box .options-box .cart-options ion-buttons.btn-outline ion-button.text-only.button-a {
  color: var(--button-a-background);
}
.item-box .options-box .cart-options ion-buttons.btn-outline ion-button.text-only.button-b {
  color: var(--button-b-background);
}
.item-box .options-box .cart-options ion-buttons.btn-outline ion-button.danger {
  color: var(--ion-color-danger);
}
.item-box .options-box .cart-options .btns-group {
  display: flex;
}
.item-box .options-box .cart-options .btns-group ion-button {
  flex: 1;
}
.item-box .options-box .price-box {
  width: 33%;
  height: auto;
  max-height: 80px;
  max-width: 110px;
  font-weight: bold;
  text-align: center;
  font-size: 1rem;
  color: #565656;
  justify-content: center;
}
.item-box .options-box .price-box ::ng-deep .price-div {
  line-height: 1;
  display: flex;
  gap: 3px;
  flex-direction: row-reverse;
  justify-content: center;
  align-items: flex-end;
}
.item-box .options-box .price-box ::ng-deep .oldprice {
  font-size: 15px;
  color: #aeaead;
  font-weight: initial;
}
.item-box .sale-span, .item-box .agent-tool-span {
  position: absolute;
  top: 4px;
  right: 0;
  left: auto;
  max-height: 34px;
  max-width: 105px;
  z-index: 1111;
}
.item-box .sale-span ion-badge, .item-box .agent-tool-span ion-badge {
  border-radius: 0;
  width: 100%;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  white-space: pre-line;
  display: flex;
  gap: 4px;
}
.item-box .sale-span ion-spinner, .item-box .agent-tool-span ion-spinner {
  width: 17px;
  height: 17px;
  color: var(--button-a-background);
}
.item-box .agent-tool-span {
  top: 40px;
  left: 0;
  right: auto;
  flex-direction: column;
  gap: 7px;
}
.item-box .agent-tool-span ion-badge {
  border-radius: 0;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  --color: var(--button-a-background);
  --background: none;
  background: white;
  border: 1px solid #f1f1f1;
  border-left: 0;
  color: var(--button-a-background);
}
.item-box .agent-tool-span ion-badge:active {
  filter: brightness(95%);
}
.item-box .sale-span.bottom {
  top: inherit;
  bottom: 3px;
}
.item-box .sale-span.last-price {
  top: 0;
  left: 5px;
  right: inherit;
  bottom: inherit;
}
.item-box .sale-span.last-price ion-badge {
  border-bottom-right-radius: 5px;
  border-bottom-left-radius: 5px;
  border-top-left-radius: 0;
  font-size: 17px;
  display: flex;
  gap: 5px;
  font-weight: 100;
}
.item-box .sale-span.last-price .maker {
  display: flex;
  gap: 5px;
  font-weight: 100;
}

.maker-span {
  position: absolute;
  top: 7px;
  right: 0px;
  bottom: inherit;
  font-size: 17px;
  display: flex;
  gap: 5px;
  font-weight: 100;
  max-height: 30px;
  max-width: 66px;
}

.item-box.small .maker-span {
  max-height: 15px;
  max-width: 30px;
}

@media screen and (min-width: 1200px) {
  .item-box .details-box .desc-box .title {
    font-size: 1rem;
  }
  .item-box .details-box .desc-box .subtitle {
    font-size: 1.4rem;
  }
}
.unit-price {
  font-weight: 100;
  display: flex;
  gap: 3px;
  align-items: center;
  font-size: 11px;
  justify-content: center;
}

.item-box.rest .desc-box .title {
  font-size: 16px !important;
  text-shadow: 1px 0px #e7e7e7;
}
.item-box.rest .desc-box .description {
  display: inherit !important;
}

.in-cart {
  box-sizing: border-box;
}
.in-cart .opacity-backg {
  --background: none;
  background: none;
}

ion-buttons.btn-outline {
  border: 1px solid #f5f5f5;
  border-radius: 4px;
}
ion-buttons.btn-outline ion-button {
  color: #565656 !important;
}
ion-buttons.btn-outline ion-button.danger {
  color: #c97f7f !important;
}

.item-box.no-border {
  border-radius: 0;
  border-right: 0;
  border-left: 0;
  border-top-width: 0;
}

.item-box.agentTechnicalTool {
  height: auto !important;
  padding: 0;
  padding-top: 5px;
}
.item-box.agentTechnicalTool .tool-header {
  padding: 2px;
}
.item-box.agentTechnicalTool .agent-options {
  position: absolute;
  bottom: 4px;
  right: 4px;
}

.item-box.small.agentTechnicalTool {
  justify-content: flex-start;
}
.item-box.small.agentTechnicalTool .details-box {
  justify-content: flex-start;
}
.item-box.small.agentTechnicalTool .details-box .agent-tool-box {
  flex: 1 1;
}
.item-box.small.agentTechnicalTool .sale-span.last-price {
  flex-direction: column;
  left: 0;
  top: 10px;
}
.item-box.small.agentTechnicalTool .sale-span.last-price ion-badge {
  border-bottom-left-radius: 0;
  border-top-right-radius: 5px;
  font-size: 11px;
}
.item-box.small.agentTechnicalTool .tool-header .img {
  min-width: 100px;
}
.item-box.small.agentTechnicalTool .tool-header {
  display: flex;
}
.item-box.small.agentTechnicalTool .tool-header .h4 {
  max-width: 150px;
}
.item-box.small.agentTechnicalTool .agent-tool-span {
  top: 50px;
}
.item-box.small.agentTechnicalTool ::ng-deep app-item-agent-tool .flex-grid {
  border-right-width: 1px;
}
.item-box.small.agentTechnicalTool ::ng-deep app-item-agent-tool .flex-grid .grid-box {
  flex: 1 1;
}

@media screen and (max-width: 800px) {
  .item-box.small.agentTechnicalTool .details-box .agent-tool-box {
    flex: auto;
  }
}
.item-box.big {
  min-height: 320px;
}
.item-box.big .details-box {
  flex-direction: column;
  flex-wrap: nowrap;
}
.item-box.big .details-box .image-box, .item-box.big .details-box .desc-box {
  width: 100%;
}
.item-box.big .details-box .desc-box {
  order: 2;
}
.item-box.big .details-box .desc-box .properties-box .maker-img {
  max-width: 105px;
  max-height: 40px;
}
.item-box.big .details-box .image-box {
  order: 1;
  height: 160px;
  min-height: 120px;
  max-width: 100%;
}
.item-box.big .details-box .image-box app-img::ng-deep .mybackground {
  min-height: 160px !important;
}
.item-box.big .options-box .cart-options {
  width: 100%;
}
.item-box.big .options-box .price-box {
  width: 50%;
  font-size: 1rem;
  white-space: nowrap;
}
.item-box.big .options-box .price-box ::ng-deep .price-div {
  flex-direction: column-reverse;
  align-items: center;
}
.item-box.big .options-box .price-box.smaller {
  width: 45%;
  font-size: 14px;
}
.item-box.big .options-box .price-box.smaller ::ng-deep .oldprice {
  font-size: 11px;
}
.item-box.big .options-box .cart-options ion-buttons, .item-box.big .options-box .cart-options ion-buttons.btn-outline {
  width: 95%;
}
.item-box.big .options-box .cart-options ion-buttons ion-button, .item-box.big .options-box .cart-options ion-buttons.btn-outline ion-button {
  border-radius: 3px !important;
  --border-radius: 3px !important;
  font-size: 14px;
  height: 35px;
  max-width: 95px;
  --padding-start: 0;
  --padding-end: 0px;
}
.item-box.big .options-box .cart-options ion-buttons ion-button span, .item-box.big .options-box .cart-options ion-buttons.btn-outline ion-button span {
  font-size: 12px;
}
.item-box.big .options-box .cart-options ion-buttons ion-button ion-icon.icon, .item-box.big .options-box .cart-options ion-buttons.btn-outline ion-button ion-icon.icon {
  font-size: 15px;
}
.item-box.big .options-box .cart-options ion-buttons ion-button.hide-on-big, .item-box.big .options-box .cart-options ion-buttons.btn-outline ion-button.hide-on-big {
  display: none;
}

.item-box.small_regular .details-box .desc-box {
  min-height: 25px;
  width: 50%;
  order: 2;
}
.item-box.small_regular .details-box .desc-box .description {
  display: none;
}
.item-box.small_regular .details-box .image-box {
  width: 25%;
  order: 1;
  margin-top: 0;
  flex: none;
  max-width: 65px;
}
.item-box.small_regular .details-box .options-box {
  display: flex;
  flex: none;
  order: 3;
  width: 26%;
  margin-top: 0px;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  align-content: space-between;
}
.item-box.small_regular .details-box .options-box .cart-options {
  width: 100%;
}
.item-box.small_regular .details-box .options-box .price-box {
  order: 3;
  width: auto;
}
.item-box.small_regular .details-box .price-box {
  font-size: 15px;
  width: auto;
}

.item-box3 ion-item {
  --padding-end: 0px;
  --inner-padding-end: 0px;
}
.item-box3 ion-item ion-label {
  margin: 0;
}
.item-box3 ion-item ion-label .item-row {
  display: flex;
  align-items: center;
}
.item-box3 .item-card {
  position: relative;
  padding: 0;
  background: var(--element-background);
  background-position: center;
  background-size: cover;
  --background: initial;
  background-repeat: no-repeat;
}
.item-box3 .item-card .title, .item-box3 .item-card p, .item-box3 .item-card .description {
  color: var(--element-color);
  --color: var(--element-color);
}
.item-box3 .item-card.big {
  height: 245px;
  margin: 3px;
  padding: 5px;
  border-radius: 2px;
  box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12);
}
.item-box3 .desc-col, .item-box3 .options-col, .item-box3 .image-col {
  padding: 5px;
}
.item-box3 .desc-col, .item-box3 .options-col {
  padding-top: 3px;
}
.item-box3 .options-col {
  padding-bottom: 2px;
}
.item-box3 .image-box {
  position: relative;
  text-align: center;
}
.item-box3 .image-box ::ng-deep app-img img {
  width: auto;
  margin: auto;
}
.item-box3 .image-box .maker-img {
  position: absolute;
  bottom: 0;
  right: 0;
  background: #fff;
}
.item-box3 .image-box .maker-img img {
  max-width: 55px;
  height: auto;
}
.item-box3 .image-box ion-thumbnail {
  min-height: 50px;
  width: 100%;
  height: 100%;
}
.item-box3 .image-box ion-thumbnail ion-skeleton-text {
  min-height: 50px;
}
.item-box3 .desc-col .desc-box .title {
  margin: 5px 0;
  white-space: pre-line;
  overflow: hidden;
  margin: 0;
}
.item-box3 .desc-col .desc-box .description {
  overflow: hidden;
}
.item-box3 .smallItemName {
  max-height: 44px;
  overflow: hidden;
  font-size: 17px;
}
.item-box3 .add-to-cart-btns-box {
  position: absolute;
  left: 0;
  z-index: 50;
  width: 100%;
  background: #fff;
  padding: 0;
}
.item-box3 .add-to-cart-btns-box ion-button {
  width: -webkit-fill-available;
  margin: 1px;
}
.item-box3 .add-to-cart-row ion-button {
  height: 35px;
  border-radius: 5px;
  --border-radius: 5px;
}
.item-box3 .add-to-cart-row .edit-cart-btn {
  --padding-start: 0;
  --padding-end: 0;
  font-size: 18px;
  font-weight: 700;
}
.item-box3 .add-to-cart-row .edit-cart-btn span {
  padding: 0 2px;
}
.item-box3 .inCart .add-to-cart-row {
  padding: 2px;
}
.item-box3 .inCart .add-to-cart-row ion-button {
  height: 30px;
}
.item-box3 .props-view-box {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 50%;
  padding: 5px 0;
}
.item-box3 .props-view-box ::ng-deep item-props-view .color-prop-box.small {
  width: 15px;
  height: 15px;
}
.item-box3 .props-view-box ::ng-deep item-props-view .colors-row {
  text-align: end;
}
.item-box3 .props-view-box ::ng-deep item-props-view .props-row {
  white-space: initial;
  overflow: scroll;
  text-align: end;
}
.item-box3 .badge-div {
  text-align: start;
  margin: 2px;
  z-index: 50;
  position: absolute;
  top: 0;
  right: 0;
  width: 50%;
}
.item-box3 .badge-div ion-badge {
  overflow: scroll;
}
.item-box3 .big .desc-col {
  padding: 0 3px;
}
.item-box3 .big .desc-box {
  height: 82px;
}
.item-box3 .big .image-box ::ng-deep app-img img {
  height: 100px;
}
.item-box3 .big .props-view-box ::ng-deep item-props-view .props-row {
  max-height: 100px;
}
.item-box3 .big .badge-div ion-badge {
  overflow: scroll;
  white-space: pre-line;
  max-height: 90px;
}
.item-box3 .big .add-to-cart-btn.danger {
  margin: 0 3px;
  width: 90%;
}
.item-box3 .big .backgroundVisible .desc-col {
  padding: 0;
}
.item-box3 .big .backgroundVisible .desc-box {
  padding: 2px;
}
.item-box3 .item-card.small ion-label {
  height: 145px;
  overflow: hidden;
}
.item-box3 .small .item-card {
  padding: 4px;
}
.item-box3 .small .add-to-cart-btns-box {
  width: 40%;
}
.item-box3 .small .add-to-cart-btns-box ion-button {
  height: 40px;
}
.item-box3 .small .add-to-cart-btn {
  max-width: 75px;
}
.item-box3 .small .add-to-cart-btn.danger {
  margin: 0;
  margin-bottom: 2px;
}
.item-box3 .small .props-view-box {
  width: 50%;
}
.item-box3 .small .props-view-box ::ng-deep item-props-view .props-row {
  max-height: 35px;
}
.item-box3 .vert-center, .item-box3 .vert-bottom {
  min-height: initial;
}

.backgroundVisible ion-item.item-card {
  background-color: none;
  --color: #fff;
}
.backgroundVisible ion-item.item-card ion-label {
  background-color: initial;
}
.backgroundVisible ion-item.item-card .desc-col, .backgroundVisible ion-item.item-card .options-col {
  background: rgba(0, 0, 0, 0.5882352941);
}
.backgroundVisible ion-item.item-card .desc-col {
  box-shadow: 0 -18px 15px 8px rgba(0, 0, 0, 0.58);
}
.backgroundVisible ion-item.item-card .desc-box {
  padding: 2px;
  background-color: rgba(0, 0, 0, 0.1);
}
.backgroundVisible ion-item.item-card .desc-col {
  color: #fff;
}
.backgroundVisible ion-item.item-card .title, .backgroundVisible ion-item.item-card p, .backgroundVisible ion-item.item-card .description {
  background-color: initial;
}

.item-box2 {
  padding: 1px;
  text-align: start;
}

.item-box2 .title {
  margin: 5px 0;
  font-size: 15px;
  max-height: 36px;
  overflow: hidden;
  margin: 0;
}

.item-box2 .item-card.big {
  max-height: 225px;
  border-radius: 5px;
  margin: 3px 3px;
  padding: 7px;
}
.item-box2 .item-card.big.catalog {
  min-height: 180px;
  max-height: 220px;
}
.item-box2 .item-card.big.catalog .desc-box {
  height: initial;
}

.item-box2 .item-card.big.rest {
  min-height: 180px;
  max-height: 245px;
  padding: 0;
}
.item-box2 .item-card.big.rest .desc-box {
  padding: 3px;
  height: initial;
}
.item-box2 .item-card.big.rest .desc-box .title, .item-box2 .item-card.big.rest .desc-box .price {
  font-weight: bold;
}
.item-box2 .item-card.big.rest .desc-box .titles {
  height: 55px;
}
.item-box2 .item-card.big.rest .add-to-cart-box .add-to-cart-btn {
  background: var(--button-a-background);
  color: var(--button-a-text);
  padding: 10px 0;
  text-align: center;
  box-shadow: 0px 0px 3px #3e3e3e;
}
.item-box2 .item-card.big.rest .add-to-cart-box .remove-btn {
  background: var(--button-b-background);
  color: var(--button-b-text);
  font-size: 19px;
  height: 100%;
  text-align: center;
  padding-top: 9px;
}

.item-box2 .item-card.small {
  margin: 2px 4px;
  padding: 0 2px;
}
.item-box2 .item-card.small ion-label {
  padding: 0 5px;
}

.item-box2 .item-card.small.sale {
  height: 85px;
  text-align: center;
}
.item-box2 .item-card.small.sale ion-label {
  text-align: center;
  padding: 0;
}
.item-box2 .item-card.small.sale ion-item {
  --padding-end: 0px;
  --inner-padding-end: 0px;
}
.item-box2 .item-card.small.sale h3 {
  height: 40px;
  white-space: pre-line;
  overflow: hidden;
  margin: 0;
}
.item-box2 .item-card.small.sale .item-card-header {
  padding: 0;
  margin-top: 2px;
  --background: var(--button-a-background);
  color: var(--button-a-text);
  border-radius: 4px;
}

.icon-color {
  color: #f0f0f0;
  margin: 5px 0;
  font-size: 40px;
}

.icon {
  margin: 5px 0;
  font-size: 40px;
}

ion-badge {
  --background: var(--button-b-background);
  --color: var(--button-b-text);
}

.item-box2 .item-card.big ion-badge {
  position: absolute;
  right: 5px;
  top: 5px;
  z-index: 50;
  max-width: 40%;
  white-space: initial;
}

ion-badge.no-absolute {
  position: initial;
}

.img-box {
  position: relative;
}
.img-box .maker-img {
  position: absolute;
  top: 4px;
  right: 0;
  position: absolute;
  bottom: 0;
  left: 0;
  background: #fff;
}
.img-box .maker-img img {
  max-width: 55px;
  height: auto;
}

.big.rest .add-to-cart-btns-box ion-buttons ion-button {
  width: -webkit-fill-available;
}

ion-segment {
  height: 38px;
}
ion-segment ion-segment-button {
  --padding-start: 2px;
  --padding-end: 2px;
  min-width: 20px;
  min-height: 42px;
  --border-width: 0;
}
ion-segment ion-icon {
  font-size: 15px;
}
ion-segment .danger {
  color: red;
}
ion-segment .primary {
  color: #0b3e6f;
}

.small.agentTechnicalTool .details-box {
  height: auto;
}

.small {
  position: relative;
}
.small .divion-item, .small ion-item {
  flex: 0 0 45%;
  --inner-padding-end: 2px;
}
.small .divion-item .item-inner, .small ion-item .item-inner {
  padding: 0;
}
.small ion-segment {
  width: 100%;
}
.small ion-segment ion-segment-button {
  min-width: 40px;
}
.small ion-segment .bold {
  font-size: 24px;
}
.small ion-segment .bold ion-icon {
  font-size: 22px;
}
.small .item-desc-box div {
  display: inline-block;
  vertical-align: middle;
}
.small .desc-box .flex-box {
  flex-direction: row !important;
  gap: 15px;
}
.small .desc-box .title {
  line-height: 1;
  margin-top: 6px;
}
.small .sale-span {
  top: -2px;
}
.small .sale-span ion-badge {
  font-size: 12px;
}
.small ::ng-deep .price-div {
  flex-direction: column-reverse !important;
}
.small .image-box {
  order: 0 !important;
}
.small .maker-img img {
  max-height: 35px;
  width: auto;
  max-width: 85px;
  padding: 0 2px;
}
@media screen and (max-width: 767px) {
  .small .details-box {
    min-height: 92px;
    flex-direction: row;
    gap: 0;
  }
  .small .details-box .desc-box {
    min-height: inherit;
    max-height: inherit;
    flex: 1;
    padding: 0 3px;
  }
  .small .details-box .options-box {
    flex: 1;
    width: inherit;
    gap: 5px;
    flex-direction: column;
    justify-content: center;
  }
  .small .details-box ::ng-deep .price-div {
    flex-direction: row-reverse !important;
    gap: 5px;
  }
}
@media screen and (min-width: 767px) {
  .small .details-box .desc-box {
    min-height: inherit;
    max-height: inherit;
    flex: 1;
  }
  .small .details-box .options-box {
    width: 30%;
    flex: 1;
  }
}

.big ion-segment ion-segment-button, .big ion-segment ion-icon {
  font-size: 21px;
}

.comments-box {
  font-size: 13px;
}
.comments-box textarea {
  border-color: rgb(234, 234, 234);
  border-radius: 3px;
  width: 100%;
  resize: none;
}

.props-box {
  line-height: 1.2;
  font-size: 14px;
  max-height: 30px;
  overflow: hidden;
}
.props-box .title {
  font-weight: bold;
  --margin-end: 2px;
}
.props-box .props span {
  font-style: italic;
}

.props-box.showAll {
  max-height: initial;
  white-space: normal;
}

.item-box {
  position: relative;
}
.item-box .actions {
  position: absolute;
  z-index: 150;
  bottom: 90px;
  left: 2px;
  background: white;
  border-radius: 5px;
  border: 1px solid #cacaca;
  padding: 5px;
  display: flex;
  align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/core/pages/item/components/app-item/app-item.component.scss"],"names":[],"mappings":"AAAA;EACE,4BAAA;EACA,WAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAQA;EACE,gBAAA;EAEA,gBAAA;EACA,yBAAA;EAEA,wDAAA;EAEA,YAAA;EACA,kBAAA;EAEA,YAAA;AATF;AAWE;EACE,aAAA;EACA,8BAAA;EACA,eAAA;EACA,QAAA;AATJ;AAWI;EAIE,UAAA;EAEA,YAAA;EAGA,QAAA;EAIA,gBAAA;AAlBN;AAqBI;EACE,QAAA;AAnBN;AAsBI;EAEE,gBAAA;EAEA,iBAAA;EACA,gBAAA;EAGA,QAAA;AAxBN;AA0BM;EACE,eAAA;EACA,cAAA;EACA,gBAAA;AAxBR;AA8BM;EACE,uBAAA;EACA,sBAAA;AA5BR;AA+BM;EACE,eAAA;EACA,eAAA;EACA,cAAA;EACA,QAAA;AA7BR;AAgCM;EACE,cAAA;EACA,eAAA;EAEA,gBAAA;EAEA,aAAA;AAhCR;AAmCU;EACE,SAAA;AAjCZ;AAoCU;EACE,SAAA;EACA,eAAA;AAlCZ;AAuCM;EAEE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,QAAA;AAtCR;AAkDQ;EAEE,YAAA;EACA,YAAA;EACA,gBAAA;AAjDV;AAmDU;EACE,eAAA;AAjDZ;AA6DY;EACE,WAAA;EACA,YAAA;AA3Dd;AA8DY;EACE,eAAA;AA5Dd;AA+DY;EACE,oBAAA;EAEA,eAAA;AA9Dd;AAqEE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;EACA,mBAAA;EAEA,QAAA;EACA,WAAA;AApEJ;AAsEI;EACE,UAAA;AApEN;AAuEM;EACE,6BAAA;AArER;AAwEM;EACE,2BAAA;AAtER;AAyEM;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;AAvER;AAyEQ;EACE,WAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;AAvEV;AA6EU;EACE,kBAAA;EACA,UAAA;EAEA,WAAA;EACA,YAAA;EACA,gBAAA;EAEA,gBAAA;EACA,kBAAA;AA7EZ;AAgFU;EACE,YAAA;AA9EZ;AAiFU;EACE,UAAA;AA/EZ;AAsFQ;EACE,gBAAA;EACA,kBAAA;EAGA,iBAAA;EACA,gBAAA;EACA,kBAAA;AAtFV;AAyFQ;EACE,SAAA;EACA,eAAA;EAEA,kBAAA;EACA,gBAAA;AAxFV;AA0FU;EACE,eAAA;EACA,cAAA;EACA,gBAAA;AAxFZ;AA4FQ;EACE,iCAAA;AA1FV;AA6FQ;EACE,iCAAA;AA3FV;AA8FQ;EAEE,8BAAA;AA7FV;AAiGM;EACE,aAAA;AA/FR;AAiGQ;EACE,OAAA;AA/FV;AAoGI;EACE,UAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EAEA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;EAEA,uBAAA;AApGN;AAuGQ;EACE,cAAA;EACA,aAAA;EACA,QAAA;EACA,2BAAA;EACA,uBAAA;EACA,qBAAA;AArGV;AAwGQ;EACE,eAAA;EACA,cAAA;EACA,oBAAA;AAtGV;AA6GE;EACE,kBAAA;EACA,QAAA;EACA,QAAA;EACA,UAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;AA3GJ;AA6GI;EACE,gBAAA;EACA,WAAA;EAEA,2BAAA;EACA,8BAAA;EACA,qBAAA;EAEA,aAAA;EACA,QAAA;AA7GN;AAgHI;EACE,WAAA;EACA,YAAA;EACA,iCAAA;AA9GN;AAkHE;EACE,SAAA;EACA,OAAA;EACA,WAAA;EACA,sBAAA;EACA,QAAA;AAhHJ;AAkHI;EACE,gBAAA;EAEA,4BAAA;EACA,+BAAA;EAEA,mCAAA;EACA,kBAAA;EACA,iBAAA;EACA,yBAAA;EACA,cAAA;EACA,iCAAA;AAlHN;AAqHI;EACE,uBAAA;AAnHN;AAuHE;EACE,YAAA;EACA,WAAA;AArHJ;AAwHE;EACE,MAAA;EACA,SAAA;EACA,cAAA;EACA,eAAA;AAtHJ;AAwHI;EACE,+BAAA;EACA,8BAAA;EACA,yBAAA;EAEA,eAAA;EACA,aAAA;EACA,QAAA;EACA,gBAAA;AAvHN;AA0HI;EACE,aAAA;EACA,QAAA;EACA,gBAAA;AAxHN;;AA+HA;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,eAAA;EACA,eAAA;EACA,aAAA;EACA,QAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;AA5HF;;AA+HA;EACE,gBAAA;EACA,eAAA;AA5HF;;AA+HA;EAIQ;IACE,eAAA;EA/HR;EAkIM;IACE,iBAAA;EAhIR;AACF;AAuIA;EACE,gBAAA;EACA,aAAA;EACA,QAAA;EACA,mBAAA;EACA,eAAA;EACA,uBAAA;AArIF;;AA0II;EACE,0BAAA;EACA,4BAAA;AAvIN;AA0II;EACE,2BAAA;AAxIN;;AA6IA;EACE,sBAAA;AA1IF;AA4IE;EACE,kBAAA;EACA,gBAAA;AA1IJ;;AAkKA;EACE,yBAAA;EACA,kBAAA;AA/JF;AAiKE;EACE,yBAAA;AA/JJ;AAkKE;EACE,yBAAA;AAhKJ;;AAqKA;EACE,gBAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;AAlKF;;AAqKA;EACE,uBAAA;EACA,UAAA;EACA,gBAAA;AAlKF;AAoKE;EACE,YAAA;AAlKJ;AAqKE;EACE,kBAAA;EACA,WAAA;EACA,UAAA;AAnKJ;;AAyKA;EACE,2BAAA;AAtKF;AAwKE;EACE,2BAAA;AAtKJ;AAwKI;EACE,SAAA;AAtKN;AA0KE;EACE,sBAAA;EACA,OAAA;EACA,SAAA;AAxKJ;AA0KI;EACE,4BAAA;EACA,4BAAA;EACA,eAAA;AAxKN;AA4KE;EACE,gBAAA;AA1KJ;AA6KE;EACE,aAAA;AA3KJ;AA8KI;EACE,gBAAA;AA5KN;AAgLE;EACE,SAAA;AA9KJ;AAmLM;EACE,uBAAA;AAjLR;AAoLQ;EACE,SAAA;AAlLV;;AAyLA;EAIM;IACE,UAAA;EAzLN;AACF;AA8LA;EAEE,iBAAA;AA7LF;AA+LE;EACE,sBAAA;EACA,iBAAA;AA7LJ;AAgMI;EACE,WAAA;AA9LN;AAiMI;EACE,QAAA;AA/LN;AAkMQ;EAEE,gBAAA;EACA,gBAAA;AAjMV;AAsMI;EACE,QAAA;EAEA,aAAA;EACA,iBAAA;EACA,eAAA;AArMN;AAwMQ;EAEE,4BAAA;AAvMV;AAiNI;EACE,WAAA;AA/MN;AAkNI;EACE,UAAA;EACA,eAAA;EACA,mBAAA;AAhNN;AAoNM;EACE,8BAAA;EACA,mBAAA;AAlNR;AAuNI;EACE,UAAA;EACA,eAAA;AArNN;AAwNQ;EACE,eAAA;AAtNV;AA4NM;EACE,UAAA;AA1NR;AA4NQ;EACE,6BAAA;EACA,+BAAA;EACA,eAAA;EACA,YAAA;EACA,eAAA;EAEA,kBAAA;EACA,kBAAA;AA3NV;AA6NU;EACE,eAAA;AA3NZ;AA8NU;EACE,eAAA;AA5NZ;AAsOQ;EACE,aAAA;AApOV;;AAsPI;EACE,gBAAA;EACA,UAAA;EACA,QAAA;AAnPN;AAqPM;EACE,aAAA;AAnPR;AAuQI;EAEE,UAAA;EACA,QAAA;EACA,aAAA;EAEA,UAAA;EACA,eAAA;AAvQN;AAsRI;EACE,aAAA;EACA,UAAA;EAEA,QAAA;EACA,UAAA;EACA,eAAA;EACA,sBAAA;EACA,mBAAA;EACA,8BAAA;EACA,4BAAA;AArRN;AAwRM;EACE,WAAA;AAtRR;AAyRM;EACE,QAAA;EACA,WAAA;AAvRR;AA2RI;EACE,eAAA;EACA,WAAA;AAzRN;;AAkSE;EAEE,kBAAA;EACA,wBAAA;AAhSJ;AAmSI;EACE,SAAA;AAjSN;AAoSM;EACE,aAAA;EACA,mBAAA;AAlSR;AAwSE;EAIE,kBAAA;EAEA,UAAA;EAEA,qCAAA;EAOA,2BAAA;EACA,sBAAA;EACA,qBAAA;EACA,4BAAA;AAjTJ;AAySI;EACE,2BAAA;EACA,6BAAA;AAvSN;AAiTE;EAEE,aAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EAIA,+GAAA;AAnTJ;AA0TE;EACE,YAAA;AAxTJ;AA2TE;EACE,gBAAA;AAzTJ;AA4TE;EACE,mBAAA;AA1TJ;AA6TE;EACE,kBAAA;EACA,kBAAA;AA3TJ;AA6TI;EACE,WAAA;EACA,YAAA;AA3TN;AA8TI;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,gBAAA;AA5TN;AA+TM;EACE,eAAA;EACA,YAAA;AA7TR;AAkUI;EACE,gBAAA;EACA,WAAA;EACA,YAAA;AAhUN;AAkUM;EACE,gBAAA;AAhUR;AA0UM;EACE,aAAA;EAEA,qBAAA;EACA,gBAAA;EACA,SAAA;AAzUR;AA6UM;EACE,gBAAA;AA3UR;AAiVE;EACE,gBAAA;EACA,gBAAA;EACA,eAAA;AA/UJ;AAmWE;EACE,kBAAA;EAEA,OAAA;EAEA,WAAA;EACA,WAAA;EACA,gBAAA;EAEA,UAAA;AApWJ;AAsWI;EAEE,6BAAA;EAGA,WAAA;AAvWN;AAiXI;EAIE,YAAA;EACA,kBAAA;EACA,oBAAA;AAlXN;AAsXI;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;AApXN;AAsXM;EACE,cAAA;AApXR;AA0XI;EACE,YAAA;AAxXN;AA0XM;EACE,YAAA;AAxXR;AA6XE;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,UAAA;EACA,cAAA;AA3XJ;AA8XM;EACE,WAAA;EACA,YAAA;AA5XR;AA+XM;EACE,eAAA;AA7XR;AAgYM;EACE,oBAAA;EACA,gBAAA;EACA,eAAA;AA9XR;AAmYE;EACE,iBAAA;EACA,WAAA;EAEA,WAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,UAAA;AAlYJ;AAqYI;EACE,gBAAA;AAnYN;AAyYI;EACE,cAAA;AAvYN;AA0YI;EACE,YAAA;AAxYN;AA4YM;EACE,aAAA;AA1YR;AAgZQ;EACE,iBAAA;AA9YV;AAoZM;EACE,gBAAA;EACA,qBAAA;EACA,gBAAA;AAlZR;AAsZI;EACE,aAAA;EACA,UAAA;AApZN;AAwZM;EACE,UAAA;AAtZR;AAyZM;EACE,YAAA;AAvZR;AAoaE;EACE,aAAA;EACA,gBAAA;AAlaJ;AAuaI;EACE,YAAA;AAraN;AA8aI;EACE,UAAA;AA5aN;AA8aM;EACE,YAAA;AA5aR;AAgbI;EACE,eAAA;AA9aN;AAibI;EACE,SAAA;EACA,kBAAA;AA/aN;AAkbI;EACE,UAAA;AAhbN;AAobQ;EACE,gBAAA;AAlbV;AAybE;EACE,mBAAA;AAvbJ;;AA4bE;EACE,sBAAA;EAoBA,aAAA;AA5cJ;AA0bI;EACE,yBAAA;AAxbN;AA2bI;EACE,uCAAA;AAzbN;AA6bI;EACE,gDAAA;AA3bN;AA8bI;EACE,YAAA;EACA,oCAAA;AA5bN;AAicI;EACE,WAAA;AA/bN;AAkcI;EACE,yBAAA;AAhcN;;AA4cA;EACE,YAAA;EACA,iBAAA;AAzcF;;AA4cA;EACE,aAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,SAAA;AAzcF;;AA4cA;EAEE,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;AA1cF;AAidA;EACE,iBAAA;EACA,iBAAA;AA/cF;AAkdE;EACE,eAAA;AAhdJ;;AAodA;EACE,iBAAA;EACA,iBAAA;EACA,UAAA;AAjdF;AAmdE;EACE,YAAA;EACA,eAAA;AAjdJ;AAmdI;EACE,iBAAA;AAjdN;AAqdI;EACE,YAAA;AAndN;AAydI;EACE,sCAAA;EACA,2BAAA;EACA,eAAA;EACA,kBAAA;EACA,+BAAA;AAvdN;AA2dI;EACE,sCAAA;EACA,2BAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;AAzdN;;AA8dA;EACE,eAAA;EACA,cAAA;AA3dF;AA6dE;EACE,cAAA;AA3dJ;;AA+dA;EACE,YAAA;EACA,kBAAA;AA5dF;AA8dE;EACE,kBAAA;EACA,UAAA;AA5dJ;AA+dE;EACE,kBAAA;EACA,wBAAA;AA7dJ;AAgeE;EACE,YAAA;EACA,qBAAA;EACA,gBAAA;EACA,SAAA;AA9dJ;AAieE;EACE,UAAA;EACA,eAAA;EACA,wCAAA;EACA,2BAAA;EACA,kBAAA;AA/dJ;;AAmeA;EACE,cAAA;EACA,aAAA;EACA,eAAA;AAheF;;AAmeA;EACE,aAAA;EACA,eAAA;AAheF;;AAmeA;EACE,wCAAA;EACA,6BAAA;AAheF;;AAqeE;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,WAAA;EACA,cAAA;EACA,oBAAA;AAleJ;;AAseA;EACE,iBAAA;AAneF;;AAyeA;EACE,kBAAA;AAteF;AAweE;EACE,kBAAA;EACA,QAAA;EACA,QAAA;EAEA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,gBAAA;AAveJ;AA0eI;EACE,eAAA;EACA,YAAA;AAxeN;;AAihBM;EACE,6BAAA;AA9gBR;;AAohBA;EAaE,YAAA;AA7hBF;AA+hBE;EACE,oBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EAEA,iBAAA;AA9hBJ;AAsiBE;EACE,eAAA;AApiBJ;AAwiBE;EACE,UAAA;AAtiBJ;AAyiBE;EACE,cAAA;AAviBJ;;AA4iBE;EACE,YAAA;AAziBJ;;AA8jBA;EACE,kBAAA;AA3jBF;AA6jBE;EACE,aAAA;EACA,wBAAA;AA3jBJ;AA6jBI;EACE,UAAA;AA3jBN;AA+jBE;EAQE,WAAA;AApkBJ;AAskBI;EACE,eAAA;AApkBN;AAukBI;EACE,eAAA;AArkBN;AAukBM;EACE,eAAA;AArkBR;AA2kBI;EACE,qBAAA;EACA,sBAAA;AAzkBN;AA8kBI;EACE,8BAAA;EACA,SAAA;AA5kBN;AA+kBI;EACE,cAAA;EACA,eAAA;AA7kBN;AAilBE;EACE,SAAA;AA/kBJ;AAilBI;EACE,eAAA;AA/kBN;AAqlBI;EACE,yCAAA;AAnlBN;AAulBE;EACE,mBAAA;AArlBJ;AAylBI;EACE,gBAAA;EACA,WAAA;EACA,eAAA;EACA,cAAA;AAvlBN;AA2lBE;EACE;IACE,gBAAA;IACA,mBAAA;IACA,MAAA;EAzlBJ;EA2lBI;IACE,mBAAA;IACA,mBAAA;IAEA,OAAA;IACA,cAAA;EA1lBN;EA6lBI;IACE,OAAA;IACA,cAAA;IAEA,QAAA;IACA,sBAAA;IACA,uBAAA;EA5lBN;EAgmBM;IACE,sCAAA;IACA,QAAA;EA9lBR;AACF;AAomBE;EAEI;IAEE,mBAAA;IACA,mBAAA;IACA,OAAA;EApmBN;EAumBI;IACE,UAAA;IAEA,OAAA;EAtmBN;AACF;;AAknBI;EACE,eAAA;AA/mBN;;AAwnBA;EACE,eAAA;AArnBF;AAunBE;EACE,gCAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;AArnBJ;;AAynBA;EACE,gBAAA;EACA,eAAA;EAEA,gBAAA;EACA,gBAAA;AAvnBF;AAynBE;EACE,iBAAA;EACA,iBAAA;AAvnBJ;AA6nBI;EACE,kBAAA;AA3nBN;;AAgoBA;EACE,mBAAA;EACA,mBAAA;AA7nBF;;AAioBA;EACE,kBAAA;AA9nBF;AAgoBE;EACE,kBAAA;EAEA,YAAA;EACA,YAAA;EACA,SAAA;EAEA,iBAAA;EACA,kBAAA;EACA,yBAAA;EAEA,YAAA;EACA,aAAA;EACA,mBAAA;AAjoBJ","sourcesContent":[".saleBadge {\n  font-size: 0.8rem !important;\n  width: auto;\n}\n\n.item-box-hidding {\n  display: none;\n}\n\n//\n//.smallImage {\n//  //max-width: 180px;\n//  //max-height: 80px;\n//}\n\n.item-box {\n  background: #fff;\n  //border-radius: 10px;\n  overflow: hidden;\n  border: 1px solid #e3e3e2;\n  //border: 1px solid #e3e3e2;\n  /* box-shadow: 0.1px 1px 7px 0 rgb(144 144 144 / 30%); */\n  //box-shadow: rgb(0 0 0 / 20%) 0px 3px 1px -2px, rgb(0 0 0 / 14%) 0px 2px 2px 0px, rgb(0 0 0 / 12%) 0px 1px 5px 0px;\n  padding: 8px;\n  position: relative;\n\n  height: 100%;\n\n  .details-box {\n    display: flex;\n    justify-content: space-between;\n    flex-wrap: wrap;\n    gap: 2px;\n\n    .image-box {\n      //height: 110px;\n      //min-width: 110px;\n\n      width: 15%;\n      //height: auto;\n      height: 80px;\n      //max-width: 110px;\n\n      order: 2;\n\n      //border-radius: 10px;\n      //border: 1px solid #e3e3e2;\n      overflow: hidden;\n    }\n\n    .agent-box {\n      order: 5;\n    }\n\n    .desc-box {\n      //width: 84%;\n      overflow: hidden;\n      //padding: 0 10px;\n      text-align: start;\n      min-height: 95px;\n      //max-height: 95px;\n\n      order: 1;\n\n      .title {\n        font-size: 1rem;\n        line-height: 1;\n        min-height: 33px;\n        //font-weight: bold;\n        //white-space: nowrap;\n        //margin-bottom: 3px;\n      }\n\n      .flex-box {\n        align-items: flex-start;\n        flex-direction: column;\n      }\n\n      .subtitle {\n        margin-top: 3px;\n        font-size: 13px;\n        color: #3b3b3b;\n        order: 1;\n      }\n\n      .description {\n        line-height: 1;\n        font-size: 13px;\n        //height: 24px;\n        overflow: hidden;\n\n        display: none;\n\n        ::ng-deep {\n          p {\n            margin: 0;\n          }\n\n          h3 {\n            margin: 0;\n            font-size: 12px;\n          }\n        }\n      }\n\n      .properties-box {\n        //padding: 5px 0;\n        display: flex;\n        align-items: center;\n        flex-direction: row;\n        order: 2;\n\n\n        div {\n          //border-left: 1px solid #ccc;\n          //margin: 0 2px;\n        }\n\n        div:last-child {\n          //border-left: 0;\n        }\n\n        .maker-img {\n          //max-width: 50px;\n          padding: 3px;\n          height: 40px;\n          line-height: 0.7;\n\n          span {\n            font-size: 13px;\n          }\n        }\n\n        .props-view-box {\n          //position: absolute;\n          //bottom: 0;\n          //right: 0;\n          //width: 50%;\n          //padding: 5px 0;\n\n          ::ng-deep item-props-view {\n            .color-prop-box.small {\n              width: 15px;\n              height: 15px;\n            }\n\n            .colors-row {\n              text-align: end;\n            }\n\n            .props-row {\n              white-space: initial;\n              //overflow: scroll;\n              text-align: end;\n            }\n          }\n        }\n      }\n    }\n  }\n  .options-box {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    margin-top: 2px;\n    align-items: center;\n\n    order: 3;\n    width: 100%;\n\n    .cart-options {\n      width: 66%;\n\n\n      ion-buttons.space-around {\n        justify-content: space-around;\n      }\n\n      ion-buttons.flex-start {\n        justify-content: flex-start;\n      }\n\n      ion-buttons {\n        display: flex;\n        flex-direction: row;\n        align-items: center;\n        overflow: hidden;\n\n        ion-button {\n          width: 100%;\n          font-size: 12px;\n          height: 35px;\n          max-width: 150px;\n\n          //border-radius: 0;\n          //--border-radius: 0;\n          //border:0;\n\n          .opacity-backg {\n            position: absolute;\n            z-index: 1;\n            //opacity: 0.8;\n            width: 100%;\n            height: 100%;\n            border-radius: 0;\n\n            background: none;\n            --background: none;\n          }\n\n          .opacity-backg.strong {\n            opacity: 0.4;\n          }\n\n          * {\n            z-index: 2;\n          }\n        }\n\n      }\n\n      ion-buttons.btn-outline {\n        ion-button {\n          background: none;\n          --background: none;\n          //border: 1px solid #e3e3e2;\n          //color: #565656;\n          font-weight: bold;\n          --padding-end: 0;\n          --padding-start: 0;\n        }\n\n        ion-button.text-only {\n          border: 0;\n          font-size: 20px;\n\n          --padding-start: 0;\n          --padding-end: 0;\n\n          span {\n            font-size: 15px;\n            color: #e3e3e2;\n            font-weight: 100;\n          }\n        }\n\n        ion-button.text-only.button-a {\n          color: var(--button-a-background);\n        }\n\n        ion-button.text-only.button-b {\n          color: var(--button-b-background);\n        }\n\n        ion-button.danger {\n          //color: #c97f7f;\n          color: var(--ion-color-danger);\n        }\n      }\n\n      .btns-group {\n        display: flex;\n\n        ion-button {\n          flex: 1;\n        }\n      }\n    }\n\n    .price-box {\n      width: 33%;\n      height: auto;\n      max-height: 80px;\n      max-width: 110px;\n\n      font-weight: bold;\n      text-align: center;\n      font-size: 1rem;\n      color: #565656;\n      //min-width: 110px;\n      justify-content: center;\n\n      ::ng-deep {\n        .price-div {\n          line-height: 1;\n          display: flex;\n          gap: 3px;\n          flex-direction: row-reverse;\n          justify-content: center;\n          align-items: flex-end;\n        }\n\n        .oldprice {\n          font-size: 15px;\n          color: #aeaead;\n          font-weight: initial;\n        }\n      }\n    }\n  }\n\n\n  .sale-span, .agent-tool-span {\n    position: absolute;\n    top: 4px;\n    right: 0;\n    left: auto;\n    max-height: 34px;\n    max-width: 105px;\n    z-index: 1111;\n\n    ion-badge {\n      border-radius: 0;\n      width: 100%;\n\n      border-top-left-radius: 5px;\n      border-bottom-left-radius: 5px;\n      white-space: pre-line;\n\n      display: flex;\n      gap: 4px;\n    }\n\n    ion-spinner {\n      width: 17px;\n      height: 17px;\n      color: var(--button-a-background);\n    }\n  }\n\n  .agent-tool-span {\n    top: 40px;\n    left: 0;\n    right: auto;\n    flex-direction: column;\n    gap: 7px;\n\n    ion-badge {\n      border-radius: 0;\n\n      border-top-right-radius: 5px;\n      border-bottom-right-radius: 5px;\n\n      --color: var(--button-a-background);\n      --background: none;\n      background: #ffff;\n      border: 1px solid #f1f1f1;\n      border-left: 0;\n      color: var(--button-a-background);\n    }\n\n    ion-badge:active {\n      filter: brightness(95%);\n    }\n  }\n\n  .sale-span.bottom {\n    top: inherit;\n    bottom: 3px;\n  }\n\n  .sale-span.last-price {\n    top: 0;\n    left: 5px;\n    right: inherit;\n    bottom: inherit;\n\n    ion-badge {\n      border-bottom-right-radius: 5px;\n      border-bottom-left-radius: 5px;\n      border-top-left-radius: 0;\n\n      font-size: 17px;\n      display: flex;\n      gap: 5px;\n      font-weight: 100;\n    }\n\n    .maker {\n      display: flex;\n      gap: 5px;\n      font-weight: 100;\n    }\n  }\n\n}\n\n\n.maker-span {\n  position: absolute;\n  top: 7px;\n  right: 0px;\n  bottom: inherit;\n  font-size: 17px;\n  display: flex;\n  gap: 5px;\n  font-weight: 100;\n  max-height: 30px;\n  max-width: 66px;\n}\n\n.item-box.small .maker-span {\n  max-height: 15px;\n  max-width: 30px;\n}\n\n@media screen and (min-width: 1200px) {\n  .item-box {\n    .details-box {\n      .desc-box {\n        .title {\n          font-size: 1rem;\n        }\n\n        .subtitle {\n          font-size: 1.4rem;\n        }\n      }\n    }\n  }\n}\n\n\n.unit-price {\n  font-weight: 100;\n  display: flex;\n  gap: 3px;\n  align-items: center;\n  font-size: 11px;\n  justify-content: center;\n}\n\n.item-box.rest {\n  .desc-box {\n    .title {\n      font-size: 16px !important;\n      text-shadow: 1px 0px #e7e7e7;\n    }\n\n    .description {\n      display: inherit !important;\n    }\n  }\n}\n\n.in-cart {\n  box-sizing: border-box;\n\n  .opacity-backg {\n    --background: none;\n    background: none;\n  }\n\n  //ion-buttons.btn-outline {\n  //  border: 1px solid #f5f5f5;\n  //  border-radius: 4px;\n  //\n  //  ion-button {\n  //    color: #565656 !important;\n  //  }\n  //\n  //  ion-button.danger {\n  //    color: #c97f7f !important;\n  //  }\n  //\n  //}\n\n  //border-bottom: 1px solid #dedede;\n\n  //border-color: #68946c;\n\n}\n\n\nion-buttons.btn-outline {\n  border: 1px solid #f5f5f5;\n  border-radius: 4px;\n\n  ion-button {\n    color: #565656 !important;\n  }\n\n  ion-button.danger {\n    color: #c97f7f !important;\n  }\n}\n\n\n.item-box.no-border {\n  border-radius: 0;\n  border-right: 0;\n  border-left: 0;\n  border-top-width: 0;\n}\n\n.item-box.agentTechnicalTool {\n  height: auto !important;\n  padding: 0;\n  padding-top: 5px;\n\n  .tool-header {\n    padding: 2px;\n  }\n\n  .agent-options {\n    position: absolute;\n    bottom: 4px;\n    right: 4px;\n    //border: 1px solid #ccc;\n    //border-radius: 3px;\n  }\n}\n\n.item-box.small.agentTechnicalTool {\n  justify-content: flex-start;\n\n  .details-box {\n    justify-content: flex-start;\n\n    .agent-tool-box {\n      flex: 1 1;\n    }\n  }\n\n  .sale-span.last-price {\n    flex-direction: column;\n    left: 0;\n    top: 10px;\n\n    ion-badge {\n      border-bottom-left-radius: 0;\n      border-top-right-radius: 5px;\n      font-size: 11px;\n    }\n  }\n\n  .tool-header .img {\n    min-width: 100px;\n  }\n\n  .tool-header {\n    display: flex;\n    //flex-direction: column-reverse;\n\n    .h4 {\n      max-width: 150px;\n    }\n  }\n\n  .agent-tool-span {\n    top: 50px;\n  }\n\n  ::ng-deep {\n    app-item-agent-tool {\n      .flex-grid {\n        border-right-width: 1px;\n\n\n        .grid-box {\n          flex: 1 1;\n        }\n      }\n    }\n  }\n}\n\n@media screen and (max-width: 800px) {\n\n  .item-box.small.agentTechnicalTool {\n    .details-box {\n      .agent-tool-box {\n        flex: auto;\n      }\n    }\n  }\n}\n\n.item-box.big {\n  //margin: 0 1px;\n  min-height: 320px;\n\n  .details-box {\n    flex-direction: column;\n    flex-wrap: nowrap;\n\n\n    .image-box, .desc-box {\n      width: 100%;\n    }\n\n    .desc-box {\n      order: 2;\n\n      .properties-box {\n        .maker-img {\n          //height: auto;\n          max-width: 105px;\n          max-height: 40px;\n        }\n      }\n    }\n\n    .image-box {\n      order: 1;\n\n      height: 160px;\n      min-height: 120px;\n      max-width: 100%;\n\n      app-img::ng-deep {\n        .mybackground {\n          //background-size: 65% auto !important;\n          min-height: 160px !important;\n          //background-position: 0 0;\n        }\n      }\n    }\n\n\n  }\n\n  .options-box {\n    .cart-options {\n      width: 100%;\n    }\n\n    .price-box {\n      width: 50%;\n      font-size: 1rem;\n      white-space: nowrap;\n\n      ::ng-deep {\n\n      .price-div {\n        flex-direction: column-reverse;\n        align-items: center;\n      }\n      }\n    }\n\n    .price-box.smaller {\n      width: 45%;\n      font-size: 14px;\n\n      ::ng-deep {\n        .oldprice {\n          font-size: 11px;\n        }\n      }\n    }\n\n    .cart-options {\n      ion-buttons, ion-buttons.btn-outline {\n        width: 95%;\n\n        ion-button {\n          border-radius: 3px !important;\n          --border-radius: 3px !important;\n          font-size: 14px;\n          height: 35px;\n          max-width: 95px;\n\n          --padding-start: 0;\n          --padding-end: 0px;\n\n          span {\n            font-size: 12px;\n          }\n\n          ion-icon.icon {\n            font-size: 15px;\n          }\n        }\n\n        ion-button.text-only {\n          //span {\n          //  display: none;\n          //}\n        }\n\n        ion-button.hide-on-big {\n          display: none;\n        }\n\n        //ion-button.danger {\n        //  display: none;\n        //}\n      }\n    }\n  }\n}\n\n.item-box.small_regular {\n  .details-box {\n\n    .image-box, .desc-box {\n      //width: 100%;\n    }\n\n    .desc-box {\n      min-height: 25px;\n      width: 50%;\n      order: 2;\n\n      .description {\n        display: none;\n      }\n\n      .flex-box {\n        //align-items: center;\n        //flex-direction: initial;\n        //flex-wrap: wrap;\n\n        .subtitle {\n          //order: 2;\n        }\n\n        .properties-box {\n          //order: 1;\n        }\n      }\n\n      //order:2\n    }\n\n    .image-box {\n\n      width: 25%;\n      order: 1;\n      margin-top: 0;\n      //order: 3;\n      flex: none;\n      max-width: 65px;\n      //order: 1;\n      //\n      //max-height: 120px;\n      //max-width: 100%;\n      //app-img::ng-deep\n      //{\n      //  .mybackground\n      //  {\n      //    min-height: 120px !important;\n      //  }\n      //}\n    }\n\n\n    .options-box {\n      display: flex;\n      flex: none;\n      //width: auto;\n      order: 3;\n      width: 26%;\n      margin-top: 0px;\n      flex-direction: column;\n      align-items: center;\n      justify-content: space-between;\n      align-content: space-between;\n\n\n      .cart-options {\n        width: 100%;\n      }\n\n      .price-box {\n        order: 3;\n        width: auto;\n      }\n    }\n\n    .price-box {\n      font-size: 15px;\n      width: auto;\n    }\n\n  }\n}\n\n\n.item-box3 {\n\n  ion-item {\n    //border: 1px solid #ccc;\n    --padding-end: 0px;\n    --inner-padding-end: 0px;\n\n\n    ion-label {\n      margin: 0;\n      //padding: 5px;\n\n      .item-row {\n        display: flex;\n        align-items: center;\n      }\n    }\n  }\n\n\n  .item-card {\n    //border-radius: 5px;\n    //margin-top: 5px;\n    //padding: 3px;\n    position: relative;\n\n    padding: 0;\n\n    background: var(--element-background);\n\n    .title, p, .description {\n      color: var(--element-color);\n      --color: var(--element-color);\n    }\n\n    background-position: center;\n    background-size: cover;\n    --background: initial;\n    background-repeat: no-repeat;\n\n  }\n\n  .item-card.big {\n    //min-height: 240px;\n    height: 245px;\n    margin: 3px;\n    padding: 5px;\n    border-radius: 2px;\n    //box-shadow: 2px 2px 1px 0px #404040;\n    //box-shadow: 2px 2px 1px 0px #ccc;\n\n    box-shadow: 0 3px 1px -2px rgb(0 0 0 / 20%), 0 2px 2px 0 rgb(0 0 0 / 14%), 0 1px 5px 0 rgb(0 0 0 / 12%);\n  }\n\n  .desc-box {\n    //height: 82px;\n  }\n\n  .desc-col, .options-col, .image-col {\n    padding: 5px;\n  }\n\n  .desc-col, .options-col {\n    padding-top: 3px;\n  }\n\n  .options-col {\n    padding-bottom: 2px;\n  }\n\n  .image-box {\n    position: relative;\n    text-align: center;\n\n    ::ng-deep app-img img {\n      width: auto;\n      margin: auto;\n    }\n\n    .maker-img {\n      position: absolute;\n      bottom: 0;\n      right: 0;\n      background: #fff;\n      //padding: 1px;\n\n      img {\n        max-width: 55px;\n        height: auto;\n\n      }\n    }\n\n    ion-thumbnail {\n      min-height: 50px;\n      width: 100%;\n      height: 100%;\n\n      ion-skeleton-text {\n        min-height: 50px;\n      }\n    }\n  }\n\n  //font-size: 0.9rem;\n\n  .desc-col {\n\n    .desc-box {\n      .title {\n        margin: 5px 0;\n        //max-height: 46px;\n        white-space: pre-line;\n        overflow: hidden;\n        margin: 0;\n        //color: white;\n      }\n\n      .description {\n        overflow: hidden;\n        //color: white;\n      }\n    }\n  }\n\n  .smallItemName {\n    max-height: 44px;\n    overflow: hidden;\n    font-size: 17px;\n  }\n\n  //.title {\n  //  font-size: 1rem;\n  //}\n\n  //@media screen and (min-width: 700px) {\n  //\n  //  .desc-col {\n  //\n  //    .desc-box {\n  //      .title {\n  //        font-size: 2rem;\n  //      }\n  //    }\n  //  }\n  //}\n\n\n  .add-to-cart-btns-box {\n    position: absolute;\n    //top: 0;\n    left: 0;\n\n    z-index: 50;\n    width: 100%;\n    background: #fff;\n\n    padding: 0;\n\n    ion-button {\n      //margin: 0 1px;\n      width: -webkit-fill-available;\n      //      width: -webkit-fill-available;\n      //      height: 45px;\n      margin: 1px;\n\n\n      //width: 30px;\n    }\n  }\n\n  .add-to-cart-row {\n    //text-align: end;\n    //display: flex;\n    ion-button {\n      //padding: 0 2px;\n      //width: 95%;\n      //display: inline-block;\n      height: 35px;\n      border-radius: 5px;\n      --border-radius: 5px;\n\n    }\n\n    .edit-cart-btn {\n      --padding-start: 0;\n      --padding-end: 0;\n      font-size: 18px;\n      font-weight: 700;\n\n      span {\n        padding: 0 2px;\n      }\n    }\n  }\n\n  .inCart {\n    .add-to-cart-row {\n      padding: 2px;\n\n      ion-button {\n        height: 30px;\n      }\n    }\n  }\n\n  .props-view-box {\n    position: absolute;\n    bottom: 0;\n    right: 0;\n    width: 50%;\n    padding: 5px 0;\n\n    ::ng-deep item-props-view {\n      .color-prop-box.small {\n        width: 15px;\n        height: 15px;\n      }\n\n      .colors-row {\n        text-align: end;\n      }\n\n      .props-row {\n        white-space: initial;\n        overflow: scroll;\n        text-align: end;\n      }\n    }\n  }\n\n  .badge-div {\n    text-align: start;\n    margin: 2px;\n    //margin-bottom: -30px;\n    z-index: 50;\n    position: absolute;\n    top: 0;\n    right: 0;\n    width: 50%;\n    //max-width: 100%;\n\n    ion-badge {\n      overflow: scroll;\n    }\n  }\n\n\n  .big {\n    .desc-col {\n      padding: 0 3px;\n    }\n\n    .desc-box {\n      height: 82px;\n    }\n\n    .image-box {\n      ::ng-deep app-img img {\n        height: 100px;\n      }\n    }\n\n    .props-view-box {\n      ::ng-deep item-props-view {\n        .props-row {\n          max-height: 100px;\n        }\n      }\n    }\n\n    .badge-div {\n      ion-badge {\n        overflow: scroll;\n        white-space: pre-line;\n        max-height: 90px;\n      }\n    }\n\n    .add-to-cart-btn.danger {\n      margin: 0 3px;\n      width: 90%;\n    }\n\n    .backgroundVisible {\n      .desc-col {\n        padding: 0;\n      }\n\n      .desc-box {\n        padding: 2px;\n      }\n    }\n\n    .desc-col, .image-box {\n      //padding-bottom: 0;\n      //margin-top: 50px;\n      //background: rgba(0, 0, 0, 0.5);\n    }\n\n\n  }\n\n  .item-card.small ion-label {\n    height: 145px;\n    overflow: hidden;\n  }\n\n  .small {\n\n    .item-card {\n      padding: 4px;\n    }\n\n    .image-box {\n      ::ng-deep app-img img {\n        //height: 145px;\n      }\n    }\n\n    .add-to-cart-btns-box {\n      width: 40%;\n\n      ion-button {\n        height: 40px;\n      }\n    }\n\n    .add-to-cart-btn {\n      max-width: 75px;\n    }\n\n    .add-to-cart-btn.danger {\n      margin: 0;\n      margin-bottom: 2px;\n    }\n\n    .props-view-box {\n      width: 50%;\n\n      ::ng-deep item-props-view {\n\n        .props-row {\n          max-height: 35px;\n        }\n      }\n    }\n  }\n\n\n  .vert-center, .vert-bottom {\n    min-height: initial;\n  }\n}\n\n.backgroundVisible {\n  ion-item.item-card {\n    background-color: none;\n\n    ion-label {\n      background-color: initial;\n    }\n\n    .desc-col, .options-col {\n      background: #00000096;\n      //padding: 0;\n    }\n\n    .desc-col {\n      box-shadow: 0 -18px 15px 8px rgb(0 0 0 / 58%);\n    }\n\n    .desc-box {\n      padding: 2px;\n      background-color: rgba(0, 0, 0, 0.1);\n    }\n\n    --color: #fff;\n\n    .desc-col {\n      color: #fff;\n    }\n\n    .title, p, .description {\n      background-color: initial;\n      //color: #fff;\n    }\n\n    //\n    //.options-box {\n    //  padding: 2px;\n    //  padding-bottom: 8px;\n    //}\n  }\n}\n\n.item-box2 {\n  padding: 1px;\n  text-align: start;\n}\n\n.item-box2 .title {\n  margin: 5px 0;\n  font-size: 15px;\n  max-height: 36px;\n  overflow: hidden;\n  margin: 0;\n}\n\n.item-box2 .item-card.big {\n  //min-height: 240px;\n  max-height: 225px;\n  border-radius: 5px;\n  margin: 3px 3px;\n  padding: 7px;\n\n  .desc-box {\n    //height: 82px;\n  }\n}\n\n.item-box2 .item-card.big.catalog {\n  min-height: 180px;\n  max-height: 220px;\n\n\n  .desc-box {\n    height: initial;\n  }\n}\n\n.item-box2 .item-card.big.rest {\n  min-height: 180px;\n  max-height: 245px;\n  padding: 0;\n\n  .desc-box {\n    padding: 3px;\n    height: initial;\n\n    .title, .price {\n      font-weight: bold;\n      //color: white; //temp1!!!!!!!!!! todo\n    }\n\n    .titles {\n      height: 55px;\n    }\n  }\n\n  .add-to-cart-box {\n\n    .add-to-cart-btn {\n      background: var(--button-a-background);\n      color: var(--button-a-text);\n      padding: 10px 0;\n      text-align: center;\n      box-shadow: 0px 0px 3px #3e3e3e;\n\n    }\n\n    .remove-btn {\n      background: var(--button-b-background);\n      color: var(--button-b-text);\n      font-size: 19px;\n      height: 100%;\n      text-align: center;\n      padding-top: 9px;\n    }\n  }\n}\n\n.item-box2 .item-card.small {\n  margin: 2px 4px;\n  padding: 0 2px;\n\n  ion-label {\n    padding: 0 5px;\n  }\n}\n\n.item-box2 .item-card.small.sale {\n  height: 85px;\n  text-align: center;\n\n  ion-label {\n    text-align: center;\n    padding: 0;\n  }\n\n  ion-item {\n    --padding-end: 0px;\n    --inner-padding-end: 0px;\n  }\n\n  h3 {\n    height: 40px;\n    white-space: pre-line;\n    overflow: hidden;\n    margin: 0;\n  }\n\n  .item-card-header {\n    padding: 0;\n    margin-top: 2px;\n    --background: var(--button-a-background);\n    color: var(--button-a-text);\n    border-radius: 4px;\n  }\n}\n\n.icon-color {\n  color: #f0f0f0;\n  margin: 5px 0;\n  font-size: 40px\n}\n\n.icon {\n  margin: 5px 0;\n  font-size: 40px;\n}\n\nion-badge {\n  --background: var(--button-b-background);\n  --color: var(--button-b-text);\n  //white-space: pre-line;\n}\n\n.item-box2 .item-card.big {\n  ion-badge {\n    position: absolute;\n    right: 5px;\n    top: 5px;\n    z-index: 50;\n    max-width: 40%;\n    white-space: initial;\n  }\n}\n\nion-badge.no-absolute {\n  position: initial;\n}\n\n.item-card {\n}\n\n.img-box {\n  position: relative;\n\n  .maker-img {\n    position: absolute;\n    top: 4px;\n    right: 0;\n\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    background: #fff;\n    //padding: 1px;\n\n    img {\n      max-width: 55px;\n      height: auto;\n\n    }\n  }\n}\n\n//\n//.small {\n//  .add-to-cart-btns-box {\n//    width: 70%;\n//    right: 50px;\n//\n//    ion-button {\n//      width: -webkit-fill-available;\n//    }\n//  }\n//\n//  .add-to-cart-btns-box.from-top.show {\n//    top: 18px;\n//  }\n//\n//  .item-name {\n//    max-height: 36px;\n//    white-space: pre-line;\n//    overflow: hidden;\n//  }\n//}\n//\n//.big {\n//  ion-buttons {\n//    ion-button {\n//      width: -webkit-fill-available;\n//      height: 45px;\n//      margin: 2px;\n//    }\n//  }\n//}\n\n.big.rest {\n  .add-to-cart-btns-box {\n    ion-buttons {\n      ion-button {\n        width: -webkit-fill-available;\n      }\n    }\n  }\n}\n\nion-segment {\n  //--border-color: var(--button-a-background);\n  //--color: var(--button-a-background);\n  //\n  //--background-focused: var(--button-a-background);\n  //--color-focused: var(--button-a-text);\n  //\n  //--background-checked: #f9f9f9;\n  //--color-checked: var(--button-a-background);\n\n  //margin: 0;\n  //background: #f9f9f9;\n\n  height: 38px;\n\n  ion-segment-button {\n    --padding-start: 2px;\n    --padding-end: 2px;\n    min-width: 20px;\n    min-height: 42px;\n\n    --border-width: 0;\n  }\n\n  ion-segment-button:active {\n    //background: var(--button-a-background);\n    //color: var(--button-a-text);\n  }\n\n  ion-icon {\n    font-size: 15px;\n  }\n\n\n  .danger {\n    color: red;\n  }\n\n  .primary {\n    color: #0b3e6f;\n  }\n}\n\n.small.agentTechnicalTool {\n  .details-box {\n    height: auto;\n  }\n}\n\n//\n//.quick-cart\n//{\n//  .details-box{\n//    height: 97px;\n//    flex-direction: column;\n//    gap:0;\n//\n//    .desc-box{\n//      width: 100% !important;\n//    }\n//    .options-box{\n//      width: 85% !important;\n//    }\n//  }\n//}\n\n.small {\n  position: relative;\n\n  .divion-item, ion-item {\n    flex: 0 0 45%;\n    --inner-padding-end: 2px;\n\n    .item-inner {\n      padding: 0;\n    }\n  }\n\n  ion-segment {\n\n    //position: absolute;\n    //top: 0;\n    //left: 0;\n    //width: fit-content;\n    //opacity: 0.95;\n    //height: 100%;\n    width: 100%;\n\n    ion-segment-button {\n      min-width: 40px;\n    }\n\n    .bold {\n      font-size: 24px;\n\n      ion-icon {\n        font-size: 22px;\n      }\n    }\n  }\n\n  .item-desc-box {\n    div {\n      display: inline-block;\n      vertical-align: middle;\n    }\n  }\n\n  .desc-box {\n    .flex-box {\n      flex-direction: row !important;\n      gap: 15px;\n    }\n\n    .title {\n      line-height: 1;\n      margin-top: 6px;\n    }\n  }\n\n  .sale-span {\n    top: -2px;\n\n    ion-badge {\n      font-size: 12px;\n    }\n\n  }\n\n  ::ng-deep {\n    .price-div {\n      flex-direction: column-reverse !important;\n    }\n  }\n\n  .image-box {\n    order: 0 !important;\n  }\n\n  .maker-img {\n    img {\n      max-height: 35px;\n      width: auto;\n      max-width: 85px;\n      padding: 0 2px;\n    }\n  }\n\n  @media screen and (max-width: 767px) {\n    .details-box {\n      min-height: 92px;\n      flex-direction: row;\n      gap: 0;\n\n      .desc-box {\n        min-height: inherit;\n        max-height: inherit;\n\n        flex: 1;\n        padding: 0 3px;\n      }\n\n      .options-box {\n        flex: 1;\n        width: inherit;\n\n        gap: 5px;\n        flex-direction: column;\n        justify-content: center;\n      }\n\n      ::ng-deep {\n        .price-div {\n          flex-direction: row-reverse !important;\n          gap: 5px;\n        }\n      }\n    }\n  }\n\n\n  @media screen and (min-width: 767px) {\n    .details-box {\n      .desc-box {\n        //width: 50%;\n        min-height: inherit;\n        max-height: inherit;\n        flex: 1;\n      }\n\n      .options-box {\n        width: 30%;\n        //width: initial;\n        flex: 1;\n      }\n    }\n  }\n\n  //.add-to-cart-btn {\n  //  height: 42px;\n  //}\n}\n\n.big {\n\n  ion-segment {\n    ion-segment-button, ion-icon {\n      font-size: 21px;\n    }\n  }\n}\n\n.close-btn-box {\n  //height: 80px;\n}\n\n.comments-box {\n  font-size: 13px;\n\n  textarea {\n    border-color: rgb(234 234 234);\n    border-radius: 3px;\n    width: 100%;\n    resize: none;\n  }\n}\n\n.props-box {\n  line-height: 1.2;\n  font-size: 14px;\n\n  max-height: 30px;\n  overflow: hidden;\n\n  .title {\n    font-weight: bold;\n    --margin-end: 2px;\n  }\n\n  .props {\n    //padding: 0 5px;\n\n    span {\n      font-style: italic;\n    }\n  }\n}\n\n.props-box.showAll {\n  max-height: initial;\n  white-space: normal;\n}\n\n\n.item-box {\n  position: relative;\n\n  .actions {\n    position: absolute;\n    //display: none;\n    z-index: 150;\n    bottom: 90px;\n    left: 2px;\n\n    background: white;\n    border-radius: 5px;\n    border: 1px solid #cacaca;\n\n    padding: 5px;\n    display: flex;\n    align-items: center;\n  }\n}\n\n//.item-box:hover{\n//  .actions{\n//    display: flex;\n//  }\n//}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
